var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crud crud-edit" },
    [
      _c("actionBarComponent", {
        attrs: {
          title: _vm.$t(
            "__.Crud.configuracaoAtendimento.edit_vue_html.tituloPagina"
          ),
        },
        on: { onSave: _vm.save },
      }),
      _vm._v(" "),
      _c(
        "form",
        {
          attrs: { novalidate: "novalidate" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              _vm.save()
            },
          },
        },
        [
          _c(
            "div",
            { attrs: { slot: "rows" }, slot: "rows" },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-2" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.errors.first("tipoAlocacaoAtendimento"),
                          expression: "errors.first('tipoAlocacaoAtendimento')",
                        },
                      ],
                      staticClass: "form-group",
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "tipoAlocacaoAtendimento" },
                        },
                        [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t(
                                  "__.Crud.configuracaoAtendimento.edit_vue_html.tipoAlocacaoAtendimento"
                                )
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("combo-component", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: {
                          id: "tipoAlocacaoAtendimento",
                          name: "tipoAlocacaoAtendimento",
                          data: _vm.tipoAlocacaoAtendimentoOptions,
                        },
                        model: {
                          value: _vm.model.tipoAlocacaoAtendimento,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "tipoAlocacaoAtendimento", $$v)
                          },
                          expression: "model.tipoAlocacaoAtendimento",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "fieldset-component",
                { attrs: { title: "Atendentes", collapsed: false } },
                [
                  _c(
                    "div",
                    { attrs: { slot: "rows" }, slot: "rows" },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.errors.first("usuarioId"),
                                  expression: "errors.first('usuarioId')",
                                },
                              ],
                              staticClass: "form-group",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "usuarioId" },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.configuracaoAtendimento.edit_vue_html.usuario"
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("combo-component", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                attrs: {
                                  id: "usuarioId",
                                  name: "usuarioId",
                                  data: _vm.usuarioOptions,
                                },
                                model: {
                                  value: _vm.usuarioId,
                                  callback: function ($$v) {
                                    _vm.usuarioId = $$v
                                  },
                                  expression: "usuarioId",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-2" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.errors.first(
                                    "perfilUsuarioAtendimento"
                                  ),
                                  expression:
                                    "errors.first('perfilUsuarioAtendimento')",
                                },
                              ],
                              staticClass: "form-group",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "perfilUsuarioAtendimento" },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.configuracaoAtendimento.edit_vue_html.perfilUsuarioAtendimento"
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("combo-component", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                attrs: {
                                  id: "perfilUsuarioAtendimento",
                                  name: "perfilUsuarioAtendimento",
                                  data: _vm.perfilUsuarioAtendimentoOptions,
                                },
                                model: {
                                  value: _vm.perfilUsuarioAtendimento,
                                  callback: function ($$v) {
                                    _vm.perfilUsuarioAtendimento = $$v
                                  },
                                  expression: "perfilUsuarioAtendimento",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-2" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                { attrs: { for: "ativoAlocacaoAutomatica" } },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.configuracaoAtendimento.edit_vue_html.ativoAlocacaoAutomatica"
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("checkbox-component", {
                                attrs: {
                                  id: "ativoAlocacaoAutomatica",
                                  name: "ativoAlocacaoAutomatica",
                                },
                                model: {
                                  value: _vm.ativoAlocacaoAutomatica,
                                  callback: function ($$v) {
                                    _vm.ativoAlocacaoAutomatica = $$v
                                  },
                                  expression: "ativoAlocacaoAutomatica",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("buttonIncluirComponent", {
                        on: { click: _vm.onAdicionaUsuario },
                      }),
                      _vm._v(" "),
                      _c("grid-component", {
                        attrs: {
                          data: _vm.model.configuracaoUsuarios,
                          columns: _vm.gridColumnsUsuarios,
                          "show-action-column": true,
                          "show-table-head": false,
                          "show-table-foot": false,
                          "show-edit-item": false,
                        },
                        on: { "remove-item": _vm.onRemoverUsuario },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "fieldset-component",
                { attrs: { title: "Horários", collapsed: false } },
                [
                  _c(
                    "div",
                    { attrs: { slot: "rows" }, slot: "rows" },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-2" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.errors.first("tipoHorario"),
                                  expression: "errors.first('tipoHorario')",
                                },
                              ],
                              staticClass: "form-group",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "tipoHorario" },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.cliente.edit_vue_html.tipo"
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("combo-component", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                attrs: {
                                  id: "tipoHorario",
                                  name: "tipoHorario",
                                  data: _vm.tiposOptions,
                                },
                                model: {
                                  value: _vm.tipoHorario,
                                  callback: function ($$v) {
                                    _vm.tipoHorario = $$v
                                  },
                                  expression: "tipoHorario",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.errors.first("horarioInicio"),
                                  expression: "errors.first('horarioInicio')",
                                },
                              ],
                              staticClass: "form-group",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "horarioInicio" },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.configuracaoAtendimento.edit_vue_html.horarioInicio"
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.horarioInicioString,
                                    expression: "horarioInicioString",
                                  },
                                  { name: "mask-hora", rawName: "v-mask-hora" },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|hora",
                                    expression: "'required|hora'",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  id: "horarioInicio",
                                  name: "horarioInicio",
                                },
                                domProps: { value: _vm.horarioInicioString },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.horarioInicioString =
                                      $event.target.value
                                  },
                                },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-4" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.errors.first("horarioFim"),
                                  expression: "errors.first('horarioFim')",
                                },
                              ],
                              staticClass: "form-group",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "horarioFim" },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.configuracaoAtendimento.edit_vue_html.horarioFim"
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.horarioFimString,
                                    expression: "horarioFimString",
                                  },
                                  { name: "mask-hora", rawName: "v-mask-hora" },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|hora",
                                    expression: "'required|hora'",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { id: "horarioFim", name: "horarioFim" },
                                domProps: { value: _vm.horarioFimString },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.horarioFimString = $event.target.value
                                  },
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("buttonIncluirComponent", {
                        on: { click: _vm.onAdicionaHorario },
                      }),
                      _vm._v(" "),
                      _c("grid-component", {
                        attrs: {
                          data: _vm.model.configuracaoAtendimentoHorario,
                          columns: _vm.gridColumsHorarios,
                          "show-action-column": true,
                          "show-table-head": false,
                          "show-table-foot": false,
                          "show-edit-item": false,
                        },
                        on: { "remove-item": _vm.onRemover },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("fieldset", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12 newbtn" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      attrs: { type: "submit" },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-save",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("__.Crud.salvar")) +
                          "\n                        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.cancel()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("__.Crud.voltar")) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }